import { render, staticRenderFns } from "./schoolinfo.vue?vue&type=template&id=1bc71562&scoped=true"
import script from "./schoolinfo.vue?vue&type=script&lang=js"
export * from "./schoolinfo.vue?vue&type=script&lang=js"
import style0 from "./schoolinfo.vue?vue&type=style&index=0&id=1bc71562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc71562",
  null
  
)

export default component.exports